(function($){
    $('.slick-gallery').each(function(){
        if ($(this).hasClass("carousel")){
            var elementColumn = this.getAttribute("slick-columns");
            var scrollOptions = JSON.parse(this.getAttribute("scroll-options")); 
            $(this).slick(optionConstructor(elementColumn, scrollOptions));
        }
    });

    $('.slick-group .slick-row').each(function(){
        var cssid = $(this).parent().attr('id');
        if ( $(this).children().length > 1) {
            let scrollOptions = JSON.parse(this.getAttribute("scroll-options"));
            scrollOptions['dots'] = true;
            scrollOptions['adaptiveHeight'] = true;
            scrollOptions['pauseOnHover'] = true;
            scrollOptions['responsive'] = [
                {
                    breakpoint: 1024,
                    settings: {
                        dots: true,
                        nextArrow: false,
                        prevArrow: false,
                    }
                },
                {
                    breakpoint: 820,
                    settings: {
                        dots: true,
                        nextArrow: false,
                        prevArrow: false,
                    }
                }
            ]; 
            $(this).slick(optionConstructor("singles", scrollOptions, `.slick-group#${cssid} > .next`, `.slick-group#${cssid} > .previous`));     
        } else {
            $(this).parent().find(".slick-arrow").remove();
            $(this).parent().removeClass("slick-group");
            $(this).removeClass("slick-row");
        }
    });
})(jQuery);